// AUTO-GENERATED from config/site-design.json by scripts/generate-site-design.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-site-design.mjs` to regenerate; CI fails on drift.
//
// Which surfaces of the new design prest0.ai itself shows. The demonstration address,
// prest0.ai/prest0design/, shows every surface regardless (src/design/previewPath.ts designShows).

/** Every surface the new design has. */
export type DesignSurface = "home" | "chat" | "about" | "for-enterprise" | "for-lawyers" | "for-individuals" | "pricing" | "legal" | "privacy-policy" | "terms-of-service" | "cookie-policy" | "sms-terms" | "auth" | "auth-action" | "auth-callback" | "accept-invite" | "signup" | "onboarding" | "start" | "team" | "mission" | "insights" | "roadmap" | "changelog" | "app" | "trust" | "security" | "demo" | "not-found" | "desktop" | "wallet" | "subscription" | "notifications" | "settings" | "profile" | "organization" | "portal-controls" | "team-roles" | "activity" | "insights-studio" | "roadmap-studio" | "integrations" | "top-up" | "terms-update" | "agreement" | "trial-start" | "roi" | "roi-calculator" | "roi-savings" | "solutions" | "file-preview" | "splash" | "band" | "skills" | "personas" | "people" | "preview-3d" | "infrastructure" | "admin-vms" | "moonshot" | "referrals" | "referral-invite" | "referral-dashboard" | "referral-terms" | "engineering" | "desktop-sign-in" | "in-app-messages" | "connect-coach" | "connect-dialogs" | "program-workstation" | "run-live-view" | "sign-in-setup";

export const DESIGN_SURFACES: readonly DesignSurface[] = [
  "home",
  "chat",
  "about",
  "for-enterprise",
  "for-lawyers",
  "for-individuals",
  "pricing",
  "legal",
  "privacy-policy",
  "terms-of-service",
  "cookie-policy",
  "sms-terms",
  "auth",
  "auth-action",
  "auth-callback",
  "accept-invite",
  "signup",
  "onboarding",
  "start",
  "team",
  "mission",
  "insights",
  "roadmap",
  "changelog",
  "app",
  "trust",
  "security",
  "demo",
  "not-found",
  "desktop",
  "wallet",
  "subscription",
  "notifications",
  "settings",
  "profile",
  "organization",
  "portal-controls",
  "team-roles",
  "activity",
  "insights-studio",
  "roadmap-studio",
  "integrations",
  "top-up",
  "terms-update",
  "agreement",
  "trial-start",
  "roi",
  "roi-calculator",
  "roi-savings",
  "solutions",
  "file-preview",
  "splash",
  "band",
  "skills",
  "personas",
  "people",
  "preview-3d",
  "infrastructure",
  "admin-vms",
  "moonshot",
  "referrals",
  "referral-invite",
  "referral-dashboard",
  "referral-terms",
  "engineering",
  "desktop-sign-in",
  "in-app-messages",
  "connect-coach",
  "connect-dialogs",
  "program-workstation",
  "run-live-view",
  "sign-in-setup",
];

/** The surfaces live on prest0.ai itself. One word per surface; removing it takes that surface back off. */
export const LIVE_ON_PREST0_AI: readonly DesignSurface[] = [
  "home",
  "chat",
  "about",
  "for-enterprise",
  "for-lawyers",
  "for-individuals",
  "pricing",
  "team",
  "mission",
  "legal",
  "privacy-policy",
  "terms-of-service",
  "cookie-policy",
  "trust",
  "security",
  "app",
  "desktop",
  "auth",
  "auth-action",
  "auth-callback",
  "signup",
  "start",
  "accept-invite",
  "wallet",
  "subscription",
  "onboarding",
  "notifications",
  "roi",
  "roi-calculator",
  "roi-savings",
  "solutions",
  "demo",
  "agreement",
  "trial-start",
  "insights-studio",
  "roadmap-studio",
  "insights",
  "referrals",
  "referral-invite",
  "referral-dashboard",
  "referral-terms",
  "settings",
  "profile",
  "organization",
  "portal-controls",
  "team-roles",
  "activity",
  "integrations",
  "top-up",
  "file-preview",
  "splash",
  "not-found",
  "skills",
  "band",
  "preview-3d",
  "terms-update",
  "sms-terms",
  "infrastructure",
  "admin-vms",
  "moonshot",
  "changelog",
  "engineering",
  "sign-in-setup",
  "personas",
  "people",
  "desktop-sign-in",
];
